import { API } from '../configs/axios/axios.config'

const LOGIN_ENDPOINT = '/auth/login'
const REFRESH_TOKEN_ENDPOINT = '/auth/refresh-token'
const LOGOUT_ENDPOINT = '/auth/logout'
const GET_CURRENT_USER_ENDPOINT = '/auth/get-current-user'
const FORGOT_PASSWORD_ENDPOINT = '/auth/forgot-password'
const RESET_PASSWORD_ENDPOINT = '/auth/reset-password'
const CHANGE_PASSWORD_ENDPOINT = '/auth/change-password'
const GET_APP_CONFIG_ENDPOINT = '/internal/get-app-config'
const LANGUAGE_SERVER_TOKEN_ENDPOINT = '/internal/language-server-token'
const IMPERSONATE_ENDPOINT = '/auth/impersonate'
const GENERATE_OTP_ENDPOINT = '/auth/generate-otp'
const VERIFY_OTP_ENDPOINT = '/auth/verify-otp'

const AUTH_SYNC_KEY = 'auth_sync_timestamp'

// Keep track of the last notification time to prevent duplicates
let lastNotificationTime = 0
const NOTIFICATION_DEBOUNCE_MS = 100

const notifyAuthChange = () => {
    const now = Date.now()
    // Prevent duplicate notifications within debounce window
    if (now - lastNotificationTime < NOTIFICATION_DEBOUNCE_MS) {
        return
    }
    lastNotificationTime = now
    localStorage.setItem(AUTH_SYNC_KEY, now.toString())
}

class _AuthService {
    login(email, password) {
        const formData = new FormData()
        formData.append('username', email)
        formData.append('password', password)

        return API.post(LOGIN_ENDPOINT, formData).then(response => {
            notifyAuthChange()
            return response
        })
    }

    refreshToken() {
        return API.post(REFRESH_TOKEN_ENDPOINT)
    }

    logout() {
        return API.post(LOGOUT_ENDPOINT).then(response => {
            notifyAuthChange()
            return response
        })
    }

    getCurrentUser() {
        return API.get(GET_CURRENT_USER_ENDPOINT)
    }

    forgotPassword(email) {
        return API.post(FORGOT_PASSWORD_ENDPOINT, { email })
    }

    resetPassword(code, newPassword) {
        return API.post(RESET_PASSWORD_ENDPOINT, { code, new_password: newPassword })
    }

    changePassword(oldPassword, newPassword) {
        return API.post(CHANGE_PASSWORD_ENDPOINT, { old_password: oldPassword, new_password: newPassword })
    }

    getAppConfig() {
        return API.get(GET_APP_CONFIG_ENDPOINT)
    }

    getLanguageServerToken() {
        return API.get(LANGUAGE_SERVER_TOKEN_ENDPOINT)
    }

    impersonate({ email }) {
        return API.post(IMPERSONATE_ENDPOINT, { email }).then(response => {
            notifyAuthChange()
            return response
        })
    }

    generateOtp() {
        return API.get(GENERATE_OTP_ENDPOINT)
    }

    verifyOtp({ otp }) {
        return API.post(VERIFY_OTP_ENDPOINT, { otp })
    }
}

const AuthService = new _AuthService()
export default AuthService
